import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';

import { Button, ButtonLink } from 'components/Button';
import ShieldIcon from './components/ShieldIcon';
import './style.scss';

/**
 * "Add an extra layer of security" — the optional 2FA offer shown when MFA is
 * NOT enabled and NOT mandatory for the user (IsMFARequired is false). The user
 * can either set up two-factor authentication or skip it and continue to the
 * dashboard.
 *
 * Reaching this screen means the auth saga has already loaded customer/loans
 * data, passed the business blocks, and set `mfaSatisfied = 'true'`. Because MFA
 * is optional here, skipping is allowed: the MFA guard already treats MFA as
 * satisfied, so navigating to the dashboard is not bounced back to setup.
 */
const OfferTwoFactor = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Best-effort: carry the user's email into the setup screens if it was
  // passed through navigation state.
  const email = location.state?.email;
  const navState = email ? { state: { email } } : undefined;

  return (
    <div className="two-factor-page">
      <Container fluid>
        <Row>
          <Col>
            <Card className="tf-card">
              <CardBody className="p-4">
                <div className="tf-header-row mb-3">
                  <span className="tf-shield"><ShieldIcon /></span>
                  <h3 className="tf-title mb-0">Add an extra layer of security</h3>
                </div>
                <p className="tf-subtitle">
                  Protect your account with two-factor authentication. It only
                  takes a minute.
                </p>

                <Button
                  type="button"
                  color="primary"
                  className="w-100 mt-2"
                  onClick={() => navigate('/two-factor/setup', navState)}
                >
                  Set up now
                </Button>

                <div className="text-center mt-3">
                  <ButtonLink
                    className="tf-link"
                    onClick={() => navigate('/consumer/dashboard')}
                  >
                    Remind me later
                  </ButtonLink>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OfferTwoFactor;
